<p-toast></p-toast>

<div *ngIf="blocked" class="overlay">
    <img src="assets/layout/images/tovlogo.png" alt="{{translations.lbl_loading}}" class="loading-image" />
    <span style="color: white; font-size: large;">{{translations.lbl_loading}}</span>
</div>


<div class="card">

    <!-- GO BACK -->
    <p-toolbar styleClass="p-mb-4">
        <ng-template pTemplate="left">
            <button pButton pRipple label="{{translations.lbl_go_Back}}" icon="pi pi-chevron-left"
                class="p-button-warning p-mr-2" (click)="goBack()"></button>
            <p-breadcrumb [model]="breadcrumbModel" [home]="homeNavigation"></p-breadcrumb>
        </ng-template>
    </p-toolbar>

    <!-- TABLE -->
    <p-table #dt [value]="coordinationCatalogList" [exportFilename]="tableName" [columns]="[
                    { field: 'store.storeId', header: '{{translations.lbl_id}} {{translations.lbl_coordination}}' },
                    { field: 'store.descri', header: '{{translations.lbl_name}}' },
                    { field: 'store.typeDescrip', header: '{{translations.lbl_type}}' }]"
        [(selection)]="selectedCoordinationCatalog" selectionMode="multiple" [rowHover]="true" dataKey="store.storeId"
        [showCurrentPageReport]="true" responsive="true">

        <!-- CAPTION -->
        <ng-template pTemplate="caption">
            <div class="p-d-flex p-ai-left p-jc-between">
                <!-- MAIN TITLE-->
                <h5 class="p-md-6">{{optionName}}</h5>
            </div>

        </ng-template>

        <ng-template pTemplate="header">

            <!-- Order -->
            <tr>
                <th pSortableColumn="store.storeId">{{translations.lbl_id}} {{translations.lbl_coordination}}</th>
                <th pSortableColumn="store.descri">{{translations.lbl_description}}</th>
                <th pSortableColumn="store.typeDescrip">{{translations.lbl_type}}</th>
                <th></th>
            </tr>

        </ng-template>

        <ng-template pTemplate="body" let-item>
            <tr [pSelectableRow]="item">
                <td>{{item?.store?.storeId ? item?.store?.storeId : 'S/N'}}</td>
                <td>{{item?.store?.descri ? item?.store?.descri : 'S/N'}}</td>
                <td>{{item?.store?.typeDescrip ? item?.store?.typeDescrip : 'S/N'}}</td>

                <td>
                    <button *ngIf="item?.store?.isRedirect != false && item?.store?.type != 'L'" pButton pRipple
                        icon="pi pi-search" class="p-button-rounded p-mr-2"
                        (click)="selectionCoordinationCatalog(item)"></button>
                    <button *ngIf="forLevelId  && item?.store?.type == forLevelId || !forLevelId" pButton pRipple
                        icon="pi pi-list" class="p-button-rounded p-button-info p-mr-2"
                        (click)="updateModule(item)"></button>

                    <button
                        *ngIf="(module=='secretary' && view=='wrkshopMngComponent') || (module=='catalogs' && view=='schoolfpg')"
                        type="button" pButton pRipple icon="pi pi-file-excel" (click)="exportExcel(item)"
                        class="p-button-success p-mr-2" pTooltip="XLS" tooltipPosition="bottom"></button>
                    <!-- <button *ngIf="(module=='secretary' || module=='catalogs') && (view=='wrkshopMngComponent' || view=='schoolfpg') && forLevelId=='L'" type="button" pButton pRipple icon="pi pi-file-pdf" (click)="exportPdf(item)" class="p-button-warning p-mr-2" pTooltip="PDF" tooltipPosition="bottom"></button> -->
                </td>

            </tr>
        </ng-template>
    </p-table>
</div>

<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>

<!-- OVERLAY SCREEN NO STORE ID -->
<div *ngIf="(this.dataForm.get('security').value)?.storeId == null" class=" overlay">
    <img src="assets/layout/images/tovlogo.png" alt="Loading Icon" class="loading-image" />
    <span style="color: white; font-size: large;">Verifica sesión e intenta mas tarde ... </span>
</div>